import { ResourceQueryService } from '@lib/common-sdk';
import { BreadcrumbDataQuery } from '@lib/ui-components';

export const CompanyBreadcrumbProvider: BreadcrumbDataQuery = {
  fetchFunction(id: string): () => Promise<any> {
    return function () {
      return ResourceQueryService.findOneByField<any>('/api/resource/companyViews', 'companyId', id);
    };
  },

  mapToBreadcrumb(data: any): string {
    return data.name;
  },

  query: 'companyViews',
};
